import { type FC } from 'react';

import { UnlockDateChip } from '@/src/components/atoms/chips/UnlockDateChip';
import { TrackedTimeDisplay } from '@/src/components-v2/display/TrackedTimeDisplay';

import {
  isTimeOnActivitySlot,
  isUnlockDateSlot,
  type TimeOnActivitySlot,
  type UnlockDateSlot,
} from './helpers';

export type RightSlotProps = TimeOnActivitySlot | UnlockDateSlot;

/**
 * Represents the modular block in the lower right corner of the card.
 * Typically used for indicating time on activity or unlock date information for assigned content.
 */
export const RightSlot: FC<RightSlotProps> = props => {
  if (isTimeOnActivitySlot(props)) {
    const { hours, minutes } = props;
    return <TrackedTimeDisplay gap={0.5} time={{ hours, minutes }} />;
  }

  if (isUnlockDateSlot(props)) {
    const { unlockDate } = props;
    return <UnlockDateChip unlockDate={unlockDate} />;
  }

  return null;
};
